export default "__VITE_ASSET__48a3c919__"